/*
 * Copyright (c) 2026, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import * as v from "valibot"

/**
 * Keep this schema with the TOTP feature; the login flow has its own validation
 * schema because it belongs to a separate feature.
 */
export const TotpCodeSchema = v.object({
    // Accept the full server-supported range because the configured length is
    // not exposed to the console.
    code: v.pipe(v.string(), v.regex(/^\d{6,8}$/, "Enter the 6–8 digit code from your authenticator app."))
})
